import { useEffect, useState } from "react";
import api from "./api";

// WALMART item-code -> WM part# (picode) map, fetched once and shared across every view.
// Rendered as a compact "WM# <part>" line under the item code (WALMART items only).
let _mapCache = null;
let _mapPromise = null;

export function loadWmPartMap() {
  if (_mapCache) return Promise.resolve(_mapCache);
  if (!_mapPromise) {
    _mapPromise = api
      .get("/ms/wm-part-map")
      .then((r) => {
        _mapCache = (r.data && r.data.map) || {};
        return _mapCache;
      })
      .catch(() => {
        _mapPromise = null;
        return {};
      });
  }
  return _mapPromise;
}

export function useWmPartMap() {
  const [map, setMap] = useState(_mapCache || {});
  useEffect(() => {
    let on = true;
    loadWmPartMap().then((m) => {
      if (on) setMap(m);
    });
    return () => {
      on = false;
    };
  }, []);
  return map;
}

// Lookup the WM part# for an item code (base and '-A' corrections both resolve). Returns "" if none.
export function wmPartNo(map, icode) {
  if (!map || !icode) return "";
  return map[String(icode).trim()] || "";
}

// Synchronous access to the already-loaded map (populated on page mount) — for XLSX export
// column builders that can't use the hook. Returns {} until the first load resolves.
export function getWmPartMapSync() {
  return _mapCache || {};
}

// Compact muted subtext shown beneath an item code. Renders nothing for non-WALMART items.
export function WmPart({ icode, map: mapProp, className = "" }) {
  const hookMap = useWmPartMap();
  const map = mapProp || hookMap;
  const pic = wmPartNo(map, icode);
  if (!pic) return null;
  return (
    <div
      className={`wm-part-no ${className}`}
      data-testid="wm-part-no"
      style={{ fontSize: 10, lineHeight: 1.2, color: "var(--muted, #94a3b8)", fontWeight: 600, letterSpacing: 0.2, marginTop: 1 }}
      title="WALMART part number"
    >
      WM# {pic}
    </div>
  );
}
